import * as Sentry from '@sentry/react';

export function formatError(error) {
    let errorData = null;
    let errorMessage = null;

    if (typeof error === 'string') {
        return error;
    }

    try {
        // Several of our handled backend errors are returned this way
        errorData = error?.data?.data?.errors?.[0]?.messages?.[0];
    } catch {
        errorData = null;
    }

    if (errorData) {
        errorMessage = errorData;
    } else if (error) {
        if (error.message) {
            errorMessage = error.message;
        } else if (error.statusText) {
            errorMessage = error.statusText;
        } else if (error?.response?.data) {
            errorMessage = JSON.stringify(error.response.data);
        } else if (error.status) {
            errorMessage = `${error.status}: ${
                window?.location?.pathname
                    ? window?.location?.pathname
                    : 'Unknown Page'
            }`;
        }
    }

    if (!errorMessage) {
        errorMessage = 'Unlabeled Error';
    }

    return errorMessage;
}

export function transformObjectToError(errorObject) {
    return errorObject instanceof Error
        ? errorObject
        : new Error(formatError(errorObject));
}

export function sendSentryMessage({
    error,
    additionalData = {},
    customErrorMessage = null,
}) {
    const errorMessage = formatError(error);

    Sentry.getCurrentScope().setExtra('data', {
        caughtError: error,
        ...additionalData,
    });
    Sentry.captureMessage(
        customErrorMessage ? customErrorMessage : errorMessage,
        'log'
    );
}

export function sendSentryException(error) {
    const errorObj = transformObjectToError(error);

    Sentry.captureException(errorObj);
}

export function transformAndReject(errorObject) {
    let error = errorObject;

    if (errorObject instanceof Error) {
        sendSentryException(errorObject);
    } else {
        error = transformObjectToError(errorObject);
    }

    return Promise.reject(error);
}
